import type { CrmPermissionStateService } from '../auth/services/crm-permission-state.service';

export const CPD_MODULE_KEY = 'cpd';
export const CPD_MY_PAGE_KEY = 'my_cpd';
export const CPD_TEAM_PAGE_KEY = 'team_cpd_main_page';

export function getCpdPageActions(
  permissionState: CrmPermissionStateService,
  pageKey: string,
): string[] {
  return permissionState.getPageActions(CPD_MODULE_KEY, pageKey);
}

export function canViewCpdPage(
  permissionState: CrmPermissionStateService,
  pageKey: string,
): boolean {
  return getCpdPageActions(permissionState, pageKey).includes('view');
}

export function hasCpdModuleAccess(permissionState: CrmPermissionStateService): boolean {
  return permissionState.hasSupportedInModule(CPD_MODULE_KEY);
}
